// extracted by mini-css-extract-plugin
module.exports = {"authModalWrapper":"styles_authModalWrapper__op6cD","bg":"styles_bg__sLQIa","bgMobile":"styles_bgMobile__gIMK9"};